<template>
    <div>
        <div class="row">
            <div class="col-md-6">
                <card>
                    <template slot="header">
                        <h5 class="card-category"></h5>
                        <h3 class="card-title">ZONE</h3>
                    </template>

                    <el-table :data="zones" v-loading="zonesLoading">
                        <el-table-column min-width="150" prop="name" label="Ime">
                            <template slot-scope="scope">
                                <span :style="{ color: scope.row.color }">{{ scope.row.name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="100" prop="numberOfParkings" label="Broj lokacija">
                            <template slot-scope="scope">
                                <span>{{ scope.row.numberOfParkings }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="100" prop="hourPrice" label="Sat">
                            <template slot-scope="scope">
                                <span>{{ scope.row.hourPrice }} EUR {{ scope.row.phoneCode }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="100" prop="dayPrice" label="Dan">
                            <template slot-scope="scope">
                                <span>{{ scope.row.dayPrice }} EUR {{ scope.row.phoneCodeDay }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="150" header-align="right" align="right" label="Actions">
                            <div slot-scope="scope" class="text-right table-actions">
                                <el-tooltip content="Izmeni" effect="light" :open-delay="300" placement="top">
                                    <base-button :type="'success'" icon size="sm"
                                        @click="client = scope.row; editClient = true" class="btn-link">
                                        <i class="tim-icons icon-pencil"></i>
                                    </base-button>
                                </el-tooltip>
                                <el-tooltip content="Lokacije" effect="light" :open-delay="300" placement="top">
                                    <base-button :type="'success'" icon size="sm" class="btn-link"
                                        @click="navigateToPage(scope.row)">
                                        <i class="tim-icons icon-settings-gear-63"></i>
                                    </base-button>
                                </el-tooltip>

                                <!-- <el-tooltip content="Obriši" effect="light" :open-delay="300" placement="top">
                                    <base-button :type="'danger'" icon size="sm" class="btn-link"
                                        @click="zone = scope.row; deletePrompt()">
                                        <i class="tim-icons icon-simple-remove"></i>
                                    </base-button>
                                </el-tooltip> -->
                            </div>
                        </el-table-column>
                    </el-table>
                </card>
            </div>

            <div class="col-md-6">
                <card>
                    <template slot="header">
                        <h5 class="card-category"></h5>
                        <h3 class="card-title">Korisnici</h3>
                    </template>
                    <base-button class="mt-3" native-type="submit" type="primary"
                        @click="user = {}; editUserDialog = true">Novi
                        korisnik</base-button>

                    <el-table :data="users" v-loading="usersLoading">
                        <el-table-column min-width="150" prop="userName" label="Ime">
                            <template slot-scope="scope">
                                <span>{{ scope.row.userName }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="200" prop="role" label="Rola">
                            <template slot-scope="scope">
                                <span>{{ scope.row.role.name }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="150" header-align="right" align="right" label="Actions">
                            <div slot-scope="scope" class="text-right table-actions">
                                <el-tooltip content="Izmeni" effect="light" :open-delay="300" placement="top">
                                    <base-button :type="'success'" icon size="sm" class="btn-link"
                                        @click="user = scope.row; editUserDialog = true">
                                        <i class="tim-icons icon-pencil"></i>
                                    </base-button>
                                </el-tooltip>
                                <el-tooltip content="Obriši" effect="light" :open-delay="300" placement="top">
                                    <base-button :type="'danger'" icon size="sm" class="btn-link"
                                        @click="user = scope.row; deleteUserPrompt()">
                                        <i class="tim-icons icon-simple-remove"></i>
                                    </base-button>
                                </el-tooltip>
                            </div>
                        </el-table-column>
                    </el-table>
                </card>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <card>
                    <template slot="header">
                        <h5 class="card-category"></h5>
                        <h3 class="card-title">Kontrolori</h3>
                    </template>
                    <base-button class="mt-3" native-type="submit" type="primary"
                        @click="employee = {}; editEmployeeDialog = true">Novi kontrolor</base-button>
                    <el-table :data="employees" v-loading="employeesLoading">
                        <el-table-column min-width="100" prop="name" label="Ime">
                            <template slot-scope="scope">
                                <span>{{ scope.row.name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="100" prop="lastName" label="Prezime">
                            <template slot-scope="scope">
                                <span>{{ scope.row.lastName }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="100" prop="userName" label="Prezime">
                            <template slot-scope="scope">
                                <span>{{ scope.row.userName }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="100" prop="password" label="Lozinka">
                            <template slot-scope="scope">
                                <span>{{ scope.row.password }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="100" prop="active" label="Status">
                            <template slot-scope="scope">
                                <span v-if="scope.row.active" style="background-color: green;">Aktivan</span>
                                <span v-else style="background-color: red;">Neaktivan</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="150" header-align="right" align="right" label="Actions">
                            <div slot-scope="scope" class="text-right table-actions">
                                <el-tooltip content="Izmeni" effect="light" :open-delay="300" placement="top">
                                    <base-button :type="'success'" icon size="sm" class="btn-link"
                                        @click="employee = scope.row; editEmployeeDialog = true">
                                        <i class="tim-icons icon-pencil"></i>
                                    </base-button>
                                </el-tooltip>
                                <el-tooltip content="Obriši" effect="light" :open-delay="300" placement="top">
                                    <base-button :type="'danger'" icon size="sm" class="btn-link"
                                        @click="employee = scope.row; deleteEmployeePrompt()">
                                        <i class="tim-icons icon-simple-remove"></i>
                                    </base-button>
                                </el-tooltip>
                            </div>
                        </el-table-column>
                    </el-table>
                </card>
            </div>

            <div class="col-md-6">
                <card>
                    <template slot="header">
                        <h5 class="card-category"></h5>
                        <h3 class="card-title">Digitalni kiosk</h3>
                    </template>
                    <base-button class="mt-3" native-type="submit" type="primary"
                        @click="kiosk = {}; editKioskDialog = true">Novi kiosk</base-button>
                    <el-table :data="kiosks" v-loading="kiosksLoading">
                        <el-table-column min-width="100" prop="name" label="Ime">
                            <template slot-scope="scope">
                                <span>{{ scope.row.name }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="100" prop="userName" label="Korisničko ime">
                            <template slot-scope="scope">
                                <span>{{ scope.row.userName }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="100" prop="password" label="Lozinka">
                            <template slot-scope="scope">
                                <span>{{ scope.row.password }}</span>
                            </template>
                        </el-table-column>


                        <el-table-column min-width="150" header-align="right" align="right" label="Actions">
                            <div slot-scope="scope" class="text-right table-actions">
                                <el-tooltip content="Izmeni" effect="light" :open-delay="300" placement="top">
                                    <base-button :type="'success'" icon size="sm" class="btn-link"
                                        @click="kiosk = scope.row; editKioskDialog = true">
                                        <i class="tim-icons icon-pencil"></i>
                                    </base-button>
                                </el-tooltip>
                                <el-tooltip content="Obriši" effect="light" :open-delay="300" placement="top">
                                    <base-button :type="'danger'" icon size="sm" class="btn-link"
                                        @click="kiosk = scope.row; deleteKioskPrompt()">
                                        <i class="tim-icons icon-simple-remove"></i>
                                    </base-button>
                                </el-tooltip>
                            </div>
                        </el-table-column>
                    </el-table>
                </card>
            </div>
        </div>
        <!-- <div class="row">
            <div class="col-md-8 ml-auto mr-auto">
                <card class="card-subcategories card-plain">
                    <template slot="header">
                        <h4 class="card-title text-center mt-5">Page Subcategories</h4>
                        <br />
                    </template>

                    <tabs type="primary" tabContentClasses="tab-subcategories" square centered class="row">
                        <tab-pane>
                            <span slot="label">
                                <i class="tim-icons icon-istanbul"></i>Home
                            </span>
                            Collaboratively administrate empowered markets via plug-and-play
                            networks. Dynamically procrastinate B2C users after installed base
                            benefits. <br /><br />
                            Dramatically visualize customer directed convergence without
                            revolutionary ROI.
                        </tab-pane>

                        <tab-pane>
                            <span slot="label">
                                <i class="tim-icons icon-bag-16"></i>Messages
                            </span>
                            Efficiently unleash cross-media information without cross-media
                            value. Quickly maximize timely deliverables for real-time schemas.
                            <br /><br />Dramatically maintain clicks-and-mortar solutions
                            without functional solutions.
                        </tab-pane>

                        <tab-pane>
                            <span slot="label">
                                <i class="tim-icons icon-settings"></i>Settings
                            </span>
                            Completely synergize resource taxing relationships via premier
                            niche markets. Professionally cultivate one-to-one customer
                            service with robust ideas. <br /><br />Dynamically innovate
                            resource-leveling customer service for state of the art customer
                            service.
                        </tab-pane>
                    </tabs>
                </card>
            </div>
        </div> -->
        <modal :show.sync="editUserDialog" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="editUserDialog = false; user = {}">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>
            <card class="stacked-form" title="Stacked Form">
                <h4 slot="header" class="card-title">Korisnik</h4>
                <form @submit.prevent>
                    <div>
                        <base-input label="Korisničko ime" type="text" v-model="user.userName"
                            placeholder="Korisničko ime">
                        </base-input>
                        <base-input label="Lozinka (Ukoliko ne menjate lozinku, ostavite prazno)" type="password"
                            v-model="user.password" placeholder="Password">
                        </base-input>
                        <base-input label="Rola" placeholder="Rola">
                            <el-select v-model="user.role" class="select-primary" name="role" value-key="id">
                                <el-option v-for="role in roles" class="select-primary" :label="role.name" :value="role"
                                    :key="role.id"></el-option>
                            </el-select>
                        </base-input>
                        <!-- <div class="form-group">
                            <base-checkbox>Subscribe to newsletter</base-checkbox>
                        </div> -->
                        <base-button class="mt-3" native-type="submit" type="primary"
                            @click="saveUser()">Sačuvaj</base-button>
                        <base-button :type="'danger'" class="mt-3" @click="editUserDialog = false; user = {}">
                            Zatvori
                        </base-button>
                    </div>
                </form>
            </card>

        </modal>

        <modal :show.sync="editEmployeeDialog" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link"
                @click="editEmployeeDialog = false; employee = {}">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>
            <card class="stacked-form" title="Stacked Form">
                <h4 slot="header" class="card-title">Kontrolor</h4>
                <form @submit.prevent>
                    <div>

                        <base-input label="Ime" type="text" v-model="employee.name" placeholder="Ime">
                        </base-input>

                        <base-input label="Prezime" type="text" v-model="employee.lastName" placeholder="Prezime">
                        </base-input>

                        <base-input label="Korisničko ime" type="text" v-model="employee.userName"
                            placeholder="Korisničko ime">
                        </base-input>
                        <base-input label="Lozinka" type="text" v-model="employee.password" placeholder="Password">
                        </base-input>
                        <base-input label="Aktivan" type="password" v-model="employee.password" placeholder="Aktivan">
                            <base-checkbox class="text-left" v-model="employee.active" />
                        </base-input>


                        <!-- <base-input label="Sektori" placeholder="Sektori">
                            <el-select v-model="employee.regions" class="select-primary" name="regions" value-key="id">
                                <el-option v-for="r in regions" class="select-primary" :label="r.name" :value="r"
                                    :key="r.id"></el-option>
                            </el-select>
                        </base-input> -->
                        <!-- <div class="form-group">
                            <base-checkbox>Subscribe to newsletter</base-checkbox>
                        </div> -->
                        <base-button class="mt-3" native-type="submit" type="primary"
                            @click="saveEmployee()">Sačuvaj</base-button>
                        <base-button :type="'danger'" class="mt-3" @click="editEmployeeDialog = false; employee = {}">
                            Zatvori
                        </base-button>
                    </div>
                </form>
            </card>

        </modal>

        <modal :show.sync="editKioskDialog" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="editKioskDialog = false; kiosk = {}">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>
            <card class="stacked-form" title="Stacked Form">
                <h4 slot="header" class="card-title">Digitalni kiosk</h4>
                <form @submit.prevent>
                    <div>

                        <base-input label="Ime" type="text" v-model="kiosk.name" placeholder="Ime">
                        </base-input>

                        <base-input label="Korisničko ime" type="text" v-model="kiosk.userName"
                            placeholder="Korisničko ime">
                        </base-input>

                        <base-input label="Lozinka" type="text" v-model="kiosk.password" placeholder="Lozinka">
                        </base-input>

                        <base-input label="Tekst za priznanicu" type="textarea">
                            <textarea placeholder="Tekst za priznanicu" v-model="kiosk.text"
                                style="height: 800px; width: 270px;">
                    </textarea>
                        </base-input>
                        <!-- <base-input label="Aktivan" type="password" v-model="employee.password" placeholder="Aktivan">
                            <base-checkbox class="text-left" v-model="employee.active" />
                        </base-input> -->


                        <!-- <base-input label="Sektori" placeholder="Sektori">
                            <el-select v-model="employee.regions" class="select-primary" name="regions" value-key="id">
                                <el-option v-for="r in regions" class="select-primary" :label="r.name" :value="r"
                                    :key="r.id"></el-option>
                            </el-select>
                        </base-input> -->
                        <!-- <div class="form-group">
                            <base-checkbox>Subscribe to newsletter</base-checkbox>
                        </div> -->
                        <base-button class="mt-3" native-type="submit" type="primary"
                            @click="saveKiosk()">Sačuvaj</base-button>
                        <base-button :type="'danger'" class="mt-3" @click="editKioskDialog = false; kiosk = {}">
                            Zatvori
                        </base-button>
                    </div>
                </form>
            </card>

        </modal>

        <modal :show.sync="editClient" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="editClient = false; client = {}">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>


            <card class="stacked-form" title="Kategorija">
                <form @submit.prevent>
                    <div>
                        <div class="row">
                            <div class="col-md-3">
                                <base-input label="Ime" type="text" v-model="client.name" placeholder="Ime">
                                </base-input>
                            </div>
                            <div class="col-md-3">
                                <base-input label="Maksimalno vreme" type="text" v-model="client.maxHours"
                                    placeholder="Maksimalno vreme">
                                </base-input>
                            </div>
                            <div class="col-md-3">
                                <base-input label="Cena po satu" type="text" v-model="client.hourPrice"
                                    placeholder="Cena po satu">
                                </base-input>
                            </div>
                            <div class="col-md-3">
                                <base-input label="Dnevna cena" type="text" v-model="client.dayPrice"
                                    placeholder="Dnevna cena">
                                </base-input>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-3">
                                <base-input label="Broj (sat)" type="text" v-model="client.phoneCode"
                                    placeholder="Broj">
                                </base-input>
                            </div>
                            <div class="col-md-3">
                                <base-input label="Broj (dan)" type="text" v-model="client.phoneCodeDay"
                                    placeholder="Broj">
                                </base-input>
                            </div>
                            <div class="col-md-3">


                                
                                <base-input label="Radno vreme (pon-pet)" type="text" v-model="client.workingHoursStartString"
                                    placeholder="">
                                </base-input>
                                <base-input label="" type="text" v-model="client.workingHoursEndString"
                                    placeholder="">
                                </base-input> 
                                
                            </div>

                            <div class="col-md-3">
                                <base-input label="Radno vreme (subota)" type="text" v-model="client.workingHoursStartSatString"
                                    placeholder="">
                                </base-input>
                                <base-input label="" type="text" v-model="client.workingHoursEndSatString"
                                    placeholder="">
                                </base-input> 

                            </div>
                            <div class="col-md-3">
                                <base-input label="Radno vreme (nedelja)" type="text" v-model="client.workingHoursStartSunString"
                                    placeholder="">
                                </base-input>
                                <base-input label="" type="text" v-model="client.workingHoursEndSunString"
                                    placeholder="">
                                </base-input> 

                            </div>
                        </div>

                    </div>
                </form>

                <base-button class="mt-3" native-type="submit" style="margin-left: 20px;" type="primary"
                    @click="saveClient()">Sačuvaj</base-button>
                <base-button class="mt-3" native-type="submit" style="margin-left: 20px;" type="danger"
                    @click="editClient = false; client = {}">Odustani</base-button>
            </card>

        </modal>
    </div>
</template>
<script>
import { TabPane, Tabs, Collapse, CollapseItem } from 'src/components';
import { TimeSelect, Table, TableColumn, Select, Option, DatePicker } from 'element-ui';
import { BaseCheckbox, BaseProgress, RouteBreadCrumb } from 'src/components';
import axios from '@/util/axiosinstance'

import swal from 'sweetalert2';
import { BaseNav, Modal } from '@/components';

export default {
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [DatePicker.name]: DatePicker,
        [TimeSelect.name]: TimeSelect,
        TabPane,
        Tabs,
        Collapse,
        CollapseItem,
        Modal
    },
    mounted() {
        this.getZones()
        this.getUsers()
        this.getEmployees()
        this.getKiosks()
        this.getRegions()
        this.getRoles()
    },
    data() {
        return {
            activeName: 'first',
            zones: [],
            url: 'https://budva.scancar.org:8443/kuca',
            zone: {},
            parkingsModal: false,
            parkings: [],
            users: [],
            user: {},
            usersLoading: false,
            zonesLoading: false,
            user: {},
            editUserDialog: false,
            roles: [],
            employee: {},
            employees: [],
            employeesLoading: false,
            regions: [],
            kiosks: [],
            kiosk: {},
            kiosksLoading: false,
            client: {},
            editClient: false,
            editEmployeeDialog: false,
            editKioskDialog: false
        };
    },
    methods: {
        getZones() {
            this.zonesLoading = true
            axios.get(this.url + '/client/getClients').then(result => {
                this.zonesLoading = false

                if (result.data.result === 'ok') {
                    this.zones = result.data.clients
                } else {

                }
            })
        },
        getRoles() {
            // this.zonesLoading = true
            axios.get(this.url + '/settings/getRoles').then(result => {
                // this.zonesLoading = false

                if (result.data.result === 'ok') {
                    this.roles = result.data.roles
                } else {

                }
            })
        },
        getRegions() {
            // this.zonesLoading = true
            axios.get(this.url + '/settings/getRegions').then(result => {
                // this.zonesLoading = false

                if (result.data.result === 'ok') {
                    this.regions = result.data.regions
                } else {

                }
            })
        },
        getEmployees() {
            this.employeesLoading = true
            axios.get(this.url + '/employee/getEmployees').then(result => {
                this.employeesLoading = false

                if (result.data.result === 'ok') {
                    this.employees = result.data.employees
                } else {

                }
            })
        },

        getKiosks() {
            this.employeesLoading = true
            axios.get(this.url + '/kiosk/getKiosks').then(result => {
                this.employeesLoading = false

                if (result.data.result === 'ok') {
                    this.kiosks = result.data.kiosks
                } else {

                }
            })
        },

        getParkings() {
            axios.get(this.url + '/client/getParkings?clientId=' + this.zone.id).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.parkings = result.data.parkings
                    this.parkingsModal = true
                } else {

                }
            })
        },
        getUsers() {
            this.usersLoading = true
            axios.get(this.url + '/user/getUsers').then(result => {
                this.usersLoading = false

                if (result.data.result === 'ok') {
                    this.users = result.data.users
                } else {

                }
            })
        },
        saveUser() {
            this.loading = true
            axios.post(this.url + '/user/saveUser', this.user).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.$notify({
                        message:
                            'Sačuvano',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                    this.editUserDialog = false
                    this.getUsers()
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        saveClient() {
            this.loading = true
            axios.post(this.url + '/client/saveClient', this.client).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.$notify({
                        message:
                            'Sačuvano',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                    this.editClient = false
                    this.client = {}
                    this.getClients()
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        saveKiosk() {
            this.loading = true
            axios.post(this.url + '/kiosk/saveKiosk', this.kiosk).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.$notify({
                        message:
                            'Sačuvano',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                    this.editKioskDialog = false
                    this.getKiosks()
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        saveEmployee() {
            this.loading = true
            axios.post(this.url + '/employee/saveEmployee', this.employee).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.$notify({
                        message:
                            'Sačuvano',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                    this.editEmployeeDialog = false
                    this.getEmployees()
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        deleteUser() {
            this.loading = true
            axios.get(this.url + '/user/deleteUser?id=' + this.user.id).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.$notify({
                        message:
                            'Obrisano',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                    this.getUsers()

                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        deleteEmployee() {
            this.loading = true
            axios.get(this.url + '/employee/deleteEmployee?id=' + this.employee.id).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.$notify({
                        message:
                            'Obrisano',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                    this.getEmployees()

                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        deleteKiosk() {
            this.loading = true
            axios.get(this.url + '/kiosk/deleteKiosk?id=' + this.kiosk.id).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.$notify({
                        message:
                            'Obrisano',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                    this.getKiosks()

                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        navigateToPage(zone) {
            this.$router.push({ name: 'ZoneParkings', params: { id: zone.id } });
        },
        deletePrompt() {
            const swalWithBootstrapButtons4 = swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                    cancelButton: "btn btn-danger btn-fill",
                },
                buttonsStyling: false,
            });
            swalWithBootstrapButtons4
                .fire({
                    title: "Da li ste sigurni da želite da obrišete zonu \"" + this.zone.name + "\"?",
                    text: ``,
                    confirmButtonText: "Da, obriši!",
                    cancelButtonText: "NE",
                    showCancelButton: true,
                })
                .then((result) => {
                    if (result.value) {

                        // const swalWithBootstrapButtons5 = swal.mixin({
                        //     customClass: {
                        //     confirmButton: "btn btn-success btn-fill",
                        //     },
                        //     buttonsStyling: false,
                        // });
                        // swalWithBootstrapButtons5.fire({
                        //     title: "Deleted!",
                        //     text: "Your file has been deleted.",
                        // });
                    }
                });
        },
        deleteUserPrompt() {
            const swalWithBootstrapButtons4 = swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                    cancelButton: "btn btn-danger btn-fill",
                },
                buttonsStyling: false,
            });
            swalWithBootstrapButtons4
                .fire({
                    title: "Da li ste sigurni da želite da obrišete korisnika \"" + this.user.userName + "\"?",
                    text: ``,
                    confirmButtonText: "Da, obriši!",
                    cancelButtonText: "NE",
                    showCancelButton: true,
                })
                .then((result) => {
                    if (result.value) {
                        this.deleteUser()
                        // const swalWithBootstrapButtons5 = swal.mixin({
                        //     customClass: {
                        //     confirmButton: "btn btn-success btn-fill",
                        //     },
                        //     buttonsStyling: false,
                        // });
                        // swalWithBootstrapButtons5.fire({
                        //     title: "Deleted!",
                        //     text: "Your file has been deleted.",
                        // });
                    }
                });
        },
        deleteKioskPrompt() {
            const swalWithBootstrapButtons4 = swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                    cancelButton: "btn btn-danger btn-fill",
                },
                buttonsStyling: false,
            });
            swalWithBootstrapButtons4
                .fire({
                    title: "Da li ste sigurni da želite da obrišete kiosk \"" + this.kiosk.name + "\"?",
                    text: ``,
                    confirmButtonText: "Da, obriši!",
                    cancelButtonText: "NE",
                    showCancelButton: true,
                })
                .then((result) => {
                    if (result.value) {
                        this.deleteKiosk()
                        // const swalWithBootstrapButtons5 = swal.mixin({
                        //     customClass: {
                        //     confirmButton: "btn btn-success btn-fill",
                        //     },
                        //     buttonsStyling: false,
                        // });
                        // swalWithBootstrapButtons5.fire({
                        //     title: "Deleted!",
                        //     text: "Your file has been deleted.",
                        // });
                    }
                });
        },
        deleteEmployeePrompt() {
            const swalWithBootstrapButtons4 = swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                    cancelButton: "btn btn-danger btn-fill",
                },
                buttonsStyling: false,
            });
            swalWithBootstrapButtons4
                .fire({
                    title: "Da li ste sigurni da želite da obrišete kontrolora \"" + this.employee.name + "\"?",
                    text: ``,
                    confirmButtonText: "Da, obriši!",
                    cancelButtonText: "NE",
                    showCancelButton: true,
                })
                .then((result) => {
                    if (result.value) {
                        this.deleteEmployee()
                        // const swalWithBootstrapButtons5 = swal.mixin({
                        //     customClass: {
                        //     confirmButton: "btn btn-success btn-fill",
                        //     },
                        //     buttonsStyling: false,
                        // });
                        // swalWithBootstrapButtons5.fire({
                        //     title: "Deleted!",
                        //     text: "Your file has been deleted.",
                        // });
                    }
                });
        }
    }
};
</script>
<style lang="scss">
/* Pozadina modala */
.custom-modal {
    background-color: rgba(0, 0, 0, 0.8);
}

.custom-modal-content {
    background-color: #3b3b5c;
    /* Tamna pozadina */
    color: #ffffff;
    /* Svetli tekst */
    border-radius: 8px;
    max-width: 800px;
    width: 800px;
}

/* Stil za telo modala */
.custom-modal-body {
    padding: 20px;
}

/* Stil za tabelu unutar modala */
.custom-table {
    width: 100%;
    border-collapse: collapse;
    background-color: #2c2c3e;
    /* Tamna pozadina tabele */
    color: rgba(255, 255, 255, 0.87);
    /* Svetlo sivi tekst */
}

.custom-table th {
    background-color: #3c3c4f;
    /* Tamna pozadina za zaglavlje */
    color: #ffffff;
    /* Beli tekst */
    padding: 10px;
    text-align: left;
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.custom-table td {
    padding: 10px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: rgba(255, 255, 255, 0.87);
    /* Svetlo sivi tekst */
}

.custom-table tr:hover {
    background-color: rgba(255, 255, 255, 0.1);
    /* Istaknuta boja za hover */
}


.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    /* Visina loadera */
    background-color: rgba(255, 255, 255, 0.7);
    /* Providna pozadina */
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
    /* Iznad ostalog sadržaja */
}

.loader {
    border: 8px solid #f3f3f3;
    /* Svetla boja */
    border-top: 8px solid #3498db;
    /* Boja animacije */
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>